
export default class EventUtils {
  static STATUS = {
    COMPLETE: 'complete',
  }

  static CODE = {
    OK: '200',
    BAD_REQUEST: '400',
    FORBIDDEN: '403',
    NOTFOUND: '404',
  }

  /*
   * Answers whose records are made up for display and must never reach the domain's stores.
   * InspectionAsChecklist (ClickUp 86e3mpnkr) sends checklist results with ids invented for
   * the answer, plus the schedule checklists themselves, which a store-wide checklist list
   * (the legacy vehicle editor's picker) would then offer to a company.
   */
  static DETACHED_EVENT_NAMES = [
    'InspectionAsChecklistNotification',
    'InspectionAsChecklistQueryOperation',
  ];

  static isDetached(event) {
    return !!event && EventUtils.DETACHED_EVENT_NAMES.includes(event.eventName);
  }

  static Send = {
  event: function(socket, event) {
    if (!socket) {
      console.error("Socket not available to send event");
      return;
    }
    socket.send(JSON.stringify(event));
  },
}

}
